import { gql } from 'graphql-request'

export const ManyPersonOccurrencesQuery = gql`
  query AllPersonOccurrences(
    $page: Int = 1
    $limit: Int = 200
    $locale: LocaleInputType!
    $where: PersonOccurrence_where_and = {}
  ) {
    PersonOccurrences(
      page: $page
      limit: $limit
      locale: $locale
      sort: "-dateStart,-dateEnd"
      where: { AND: [{ _status: { equals: published } }, $where] }
    ) {
      docs {
        id
        title
        dateStart
        dateEnd
        isOngoing
        type
        person {
          id
          slug
          sortValue
        }
      }
      totalDocs
      hasNextPage
    }
  }
`

export const ManyCurrentPersonOccurrencesQuery = gql`
  query AllCurrentPersonOccurrences(
    $page: Int = 1
    $limit: Int = 200
    $locale: LocaleInputType!
    $where: PersonOccurrence_where_and = {}
    $isPreview: Boolean! = false
    $statuses: [PersonOccurrence__status_Input] = [published]
  ) {
    PersonOccurrences(
      draft: $isPreview
      page: $page
      limit: $limit
      locale: $locale
      sort: "-dateStart,-dateEnd"
      where: { AND: [{ _status: { in: $statuses } }, $where] }
    ) {
      docs {
        id
        title
        dateStart
        dateEnd
        isOngoing
        type
        person {
          id
          slug
          sortValue
        }
      }
      totalDocs
      hasNextPage
    }
  }
`
